// 游戏/分类数据的本地化（纯函数，客户端与服务端均可 import）
// 规则：en 模式下展示字段替换为英文资料，为空时回退中文；
//       保留中文字段原名供封面图拼路径（gamelistpic2/<中文名>.webp 规则不变）
import type { Game } from './game-types'
import type { Category } from './categories'
import type { Locale } from './i18n'

/** nameZh/catelogZh 保留中文原值：封面图路径、分类筛选匹配都用中文 key */
export type LocalizedGame = Game & { nameZh: string }

export function localizedGame(game: Game, locale: Locale): LocalizedGame {
    if (locale !== 'en') return { ...game, nameZh: game.name }
    return {
        ...game,
        nameZh: game.name,
        name: game.name_en || game.name,
        一句话描述: game.one_liner_en || game.一句话描述,
        游戏简介: game.intro_en || game.游戏简介,
        基本玩法: game.gameplay_en || game.基本玩法,
        适合区域: game.region_en || game.适合区域,
        游玩人数: game.players_en || game.游玩人数,
        支持语言: game.languages_en || game.支持语言,
        适配运营场景: game.scenarios_en || game.适配运营场景,
        标签: game.tags_en || game.标签,
        视频介绍: game.video_intro_en || game.视频介绍,
    }
}

export function localizedGames(games: Game[], locale: Locale): LocalizedGame[] {
    return games.map((g) => localizedGame(g, locale))
}

/** 分类显示名：en 且有英文名时用英文，否则中文 */
export function categoryLabel(cat: Pick<Category, 'name' | 'name_en'>, locale: Locale): string {
    return locale === 'en' && cat.name_en ? cat.name_en : cat.name
}

/** 封面取图统一规则：后台上传过列表图（/media/ 前缀）优先用上传图，否则按中文名取 gamelistpic2 默认封面（domino 与 Domino 共用一张） */
export function gameCover(game: Pick<Game, 'imageUrl'> & { nameZh: string }): string {
    if (game.imageUrl && game.imageUrl.startsWith('/media/')) return game.imageUrl
    return `/img/gamelistpic2/${game.nameZh === 'domino' ? 'Domino' : game.nameZh}.webp`
}
